/**
 * The set of manual facilitator actions recorded in the event audit log.
 */
export enum FacilitatorAuditAction {
  ADJUST_TEAM_SCORE = 'ADJUST_TEAM_SCORE',
  REFUND_CLUE = 'REFUND_CLUE',
  RESTART_CHALLENGE = 'RESTART_CHALLENGE',
  MARK_CHALLENGE_TASK_COMPLETED = 'MARK_CHALLENGE_TASK_COMPLETED',
  ASSIGN_USER_TO_TEAM = 'ASSIGN_USER_TO_TEAM',
  UNASSIGN_USER_FROM_TEAM = 'UNASSIGN_USER_FROM_TEAM',
  ADD_TIME_TO_EVENT = 'ADD_TIME_TO_EVENT',
  SUBTRACT_TIME_FROM_EVENT = 'SUBTRACT_TIME_FROM_EVENT',
  LOCK_EVENT_CHALLENGES = 'LOCK_EVENT_CHALLENGES',
  UNLOCK_EVENT_CHALLENGES = 'UNLOCK_EVENT_CHALLENGES',
}

/**
 * Action-specific fields. Any field not relevant to a given action is null, so all fields are
 * optional/nullable and must be read defensively. `points` and `totalTimeSeconds` are serialized
 * as strings by the API.
 */
export interface FacilitatorAuditLogDetails {
  teamName?: string | null;
  challengeId?: string | null;
  targetId?: string | null;
  taskId?: string | null;
  clueId?: string | null;
  points?: string | null;
  totalTimeSeconds?: string | null;
}

/**
 * A single facilitator audit log entry as returned by GET /facilitator/{eventName}/audit.
 */
export interface FacilitatorAuditLogEntry {
  action: FacilitatorAuditAction | string;
  actorVibeId: string;
  time: string;
  details: FacilitatorAuditLogDetails;
}
